import React from "react";
import { useAuthContext } from "../context/AuthContext";
import { useCartContext } from "../context/CartContext";

// Imports
import Navbar from "./Navbar";
import AuthComponent from "./AuthComponent";
import CartComponent from "./CartComponent";
import NavigationBar from "./NavigationBar";
import Notification from "./Notification";
import TC from "./T&C";
import TCPP from "./TC&PP"


const navigationLinks = [
  { title: "My Profile", link: "/my-profile" },
  { title: "My Order", link: "/my-order" },
  { title: "Family Member", link: "/family-member" },
  { title: "My Address", link: "/my-address" },
  { title: "Support", link: "/support" },
];

const DashboardWrapper = ({
  children,
  navigation = true,
  style = true,
  searchVisible,
}) => {
  const { notificationData, isAuth, isTCPP, isTC } = useAuthContext();
  const { isCart } = useCartContext();

  const handleLocationClick = () => {
    alert(
      " Location permission denied.\n\n" +
      " Please enable location access manually:\n" +
      "- Click the lock icon 🔒 in the address bar\n" +
      "- Set Location to Allow\n" +
      "- Reload the page"
    );
  };
  return (
    <>
      <div className="w-full lg:w-screen h-fit lg:h-screen bg-whiteColor flex flex-col justify-start items-center pt-[20%] lg:pt-[7%] pb-[3%] lg:pb-[1%] px-[3%] lg:px-[25%]">
        {/* <Navbar searchVisible={searchVisible} /> */}
        <Navbar searchVisible={false} />
        <Navbar locationCardVisibility={handleLocationClick} />
        {navigation && (
          <div className="w-full h-fit hidden lg:block">
            <NavigationBar navigationLinks={navigationLinks} />
          </div>
        )}
        <div
          className={`w-full ${navigation ? "h-fit lg:h-[85%]" : "h-fit lg:h-[95%]"
            } ${style &&
            "bg-whiteColor lg:bg-secondaryColor rounded-2xl lg:rounded-3xl px-[3%] lg:px-[5%]  lg:py-[4%] mt-[3%] lg:mt-[4%]"
            } overflow-x-hidden overflow-y-scroll scrollbar-hide`}
        >
          {children}
        </div>
      </div>
      {isAuth && <AuthComponent />}
      {isCart && <CartComponent />}
      {isTCPP && <TCPP />}
      {isTC && <TC />}
      {notificationData?.message?.length > 0 && <Notification />}
    </>
  );
};

export default DashboardWrapper;
